// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import { NumberInput } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../../commonComponents";

// Internals imports
import { TEMPLATE, WORKFLOW } from "../../../../constants";
import { getClauseOptionView } from "../../../../utils/documentUtils";

// Destructuring
const { DYNAMIC_FIELD_OPTIONS } = TEMPLATE;
const { CHAR_OPERATORS } = WORKFLOW;

function _decideOperator(data) {
  return data === "AND" ? "OR" : "AND";
}

function extractContent(s) {
  const span = document.createElement("span");
  span.innerHTML = s;
  const text = span.textContent || span.innerText;
  span.remove();
  return text;
}

class TempWFConditionsList extends Component {
  state = {
    clauseOptionMap: {},
    clauseOptions: [],
  };

  componentDidMount() {
    const {
      fieldData: {
        meta: { clauses },
      },
    } = this.props;
    if (clauses) {
      const clauseOptionMap = {};
      clauses.forEach(option => {
        clauseOptionMap[option.id] = extractContent(
          getClauseOptionView(option.value),
        );
      });
      const clauseOptions = clauses.map(option => ({
        name: ReactHtmlParser(getClauseOptionView(option.value)),
        value: option.id,
      }));
      this.setState({
        clauseOptionMap,
        clauseOptions,
      });
    }
  }

  // get the clause fields
  _decideClauseConditionsFields = data => {
    const {
      index,
      onSelectChange,
      fieldData,
      tempWFCondition,
      onRemoveCondition,
      toggleLogicalOperatorVisibility,
    } = this.props;
    const { conditions, logicalOperator, showOperators } = tempWFCondition;
    const totalEntries = (conditions && conditions.length - 1) || 0;
    const fieldType = fieldData.meta.subtype;
    let clauseField = null;
    if (
      fieldType === "single_select" ||
      fieldType === "multi_select" ||
      fieldType === "optional"
    ) {
      const { clauseOptionMap, clauseOptions } = this.state;
      clauseField = (
        <ReactSelect
          onChange={value => onSelectChange("value", value.value, index)}
          options={clauseOptions}
          value={clauseOptionMap[data.value] || ""}
          valueKey="value"
          labelKey="name"
          data-test="tempwfconditionslist-clausefield-select"
        />
      );
    }
    return (
      <div>
        <div className="wfconditionslist-list-wrapper">
          <div className="wfconditionslist-title-wrapper">
            <div className="wfconditionslist-list-title">
              Condition {index + 1}
            </div>
            <span
              className="wfconditionslist-delete-ico"
              onClick={() => {
                onRemoveCondition(index);
              }}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "trash-alt"]} />
            </span>
          </div>
          <div className="tempwfconditionslist-split-wrapper">
            <div className="tempwfconditionslist-div-wrapper">
              <span className="revvform-label">Trigger Approval flow if</span>
              <ReactSelect
                value={
                  fieldType === "free_text"
                    ? "If the user enters any value or replaces default value"
                    : "Trigger Approval flow if equal to"
                }
                options={[]}
                onChange={() => {}}
                isDisabled
                data-test="tempwfconditionslist-approval-flow-select"
              />
            </div>
            <div className="wfconditionslist-div-wrapper">
              <span className="revvform-label">
                {fieldType === "free_text" ? "" : "Select Clause Option"}
              </span>
              {clauseField}
            </div>
          </div>
        </div>
        {totalEntries !== index && totalEntries !== 0 && (
          <div
            className="wfconditionslist-lg-wrapper"
            onMouseEnter={toggleLogicalOperatorVisibility}
            onMouseLeave={toggleLogicalOperatorVisibility}>
            <div className="wfconditionslist-label">
              {logicalOperator}{" "}
              <span>
                <FontAwesomeIcon icon={["far", "angle-down"]} />
              </span>
            </div>
            {showOperators && (
              <div
                className="wfconditionslist-lg-options"
                onClick={() =>
                  onSelectChange(
                    "logicalOperator",
                    _decideOperator(logicalOperator),
                  )
                }
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                {_decideOperator(logicalOperator)}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // eslint-disable-next-line no-unused-vars
  _decideDynamicFields = data => {
    const {
      fieldData,
      index,
      onRemoveCondition,
      onSelectChange,
      tempWFCondition,
      toggleLogicalOperatorVisibility,
    } = this.props;
    const { conditions, logicalOperator, showOperators } = tempWFCondition;
    const totalEntries = (conditions && conditions.length - 1) || 0;
    const fieldType = DYNAMIC_FIELD_OPTIONS[fieldData.type];
    let clauseField = null;

    switch (fieldType) {
      case "single_select":
        clauseField = (
          <Fragment>
            <div className="tempwfconditionslist-div-wrapper">
              <span className="wfconditionslist-label">
                Trigger Approval flow if
              </span>
              <ReactSelect
                value="Value selected is"
                options={[]}
                onChange={() => {}}
                isDisabled
                data-test="tempwfconditionslist-trigger-approval-select"
              />
            </div>
            <div className="wfconditionslist-div-wrapper">
              <span className="wfconditionslist-label">Select Value</span>
              <ReactSelect
                onChange={value => onSelectChange("value", value.value, index)}
                options={fieldData.meta.options}
                value={data.value || ""}
                valueKey="value"
                labelKey="name"
                data-test="tempwfconditionslist-valeue-select"
              />
            </div>
          </Fragment>
        );
        break;
      case "number":
        clauseField = (
          <Fragment>
            <div className="tempwfconditionslist-div-wrapper">
              <span className="wfconditionslist-label">
                Trigger Approval flow if
              </span>
              <ReactSelect
                onChange={value => onSelectChange("rel_op", value.value, index)}
                options={CHAR_OPERATORS}
                value={data.rel_op || ""}
                valueKey="value"
                labelKey="name"
                data-test="tempwfconditionslist-approval-flow-select"
              />
            </div>
            <div className="wfconditionslist-div-wrapper">
              <span className="wfconditionslist-label">Value</span>
              <NumberInput
                placeholder="Enter Value"
                value={data.value || ""}
                onChange={value =>
                  onSelectChange("value", value ? value.toString() : "", index)
                }
                data-test="tempwfconditionslist-approval-value-select"
              />
            </div>
          </Fragment>
        );
        break;
      default:
        return null;
    }

    return (
      <div>
        <div className="wfconditionslist-list-wrapper">
          <div className="wfconditionslist-title-wrapper">
            <div className="wfconditionslist-list-title">
              Condition {index + 1}
            </div>
            <span
              className="wfconditionslist-delete-ico"
              onClick={() => {
                onRemoveCondition(index);
              }}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "trash-alt"]} />
            </span>
          </div>
          <div className="tempwfconditionslist-split-wrapper">
            {clauseField}
          </div>
        </div>
        {totalEntries !== index && totalEntries !== 0 && (
          <div
            className="wfconditionslist-lg-wrapper"
            onMouseEnter={toggleLogicalOperatorVisibility}
            onMouseLeave={toggleLogicalOperatorVisibility}>
            <div className="wfconditionslist-label">
              {logicalOperator}{" "}
              <span>
                <FontAwesomeIcon icon={["far", "angle-down"]} />
              </span>
            </div>
            {showOperators && (
              <div
                className="wfconditionslist-lg-options"
                onClick={() =>
                  onSelectChange(
                    "logicalOperator",
                    _decideOperator(logicalOperator),
                  )
                }
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                {_decideOperator(logicalOperator)}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  _decideConditionFields = () => {
    const { entity: { type } = {}, data } = this.props;
    if (type === "CLAUSE") {
      return this._decideClauseConditionsFields(data);
    }
    if (type === "DYNAMICFIELD") {
      return this._decideDynamicFields(data);
    }
    return null;
  };

  render() {
    return this._decideConditionFields();
  }
}

const mapStateToProps = state => {
  const {
    workflow: { entity },
  } = state.TemplateStore;
  return {
    entity,
  };
};

export default connect(mapStateToProps)(TempWFConditionsList);



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/TempWFConditions/TempWFConditionsList.js